<template>
  <div class="main-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <h1>运营数据概览</h1>
      <div class="update-time">最后更新时间: {{ updateTime }}</div>
    </div>

    <!-- 数据卡片区域 -->
    <div class="data-cards">
      <div class="data-card">
        <div class="card-icon total-users">
          <i class="el-icon-user"></i>
        </div>
        <div class="card-content">
          <div class="card-title">总用户数</div>
          <div class="card-value">{{ totalUsers }}</div>
          <div class="card-trend positive">
            <i class="el-icon-arrow-up"></i>
            较昨日 +{{ totalUsersIncrease }}
          </div>
        </div>
      </div>

      <div class="data-card">
        <div class="card-icon new-users">
          <i class="el-icon-plus"></i>
        </div>
        <div class="card-content">
          <div class="card-title">新增用户</div>
          <div class="card-value">{{ newUsers }}</div>
          <div class="card-trend positive">
            <i class="el-icon-arrow-up"></i>
            较昨日 +{{ newUsersIncrease }}
          </div>
        </div>
      </div>

      <div class="data-card">
        <div class="card-icon active-users">
          <i class="el-icon-connection"></i>
        </div>
        <div class="card-content">
          <div class="card-title">当日登录用户</div>
          <div class="card-value">{{ activeUsers }}</div>
          <div class="card-trend positive">
            <i class="el-icon-arrow-up"></i>
            较昨日 +{{ activeUsersIncrease }}
          </div>
        </div>
      </div>

      <div class="data-card">
        <div class="card-icon vip-users">
          <i class="el-icon-star-on"></i>
        </div>
        <div class="card-content">
          <div class="card-title">VIP用户</div>
          <div class="card-value">{{ vipUsers }}</div>
          <div class="card-trend positive">
            <i class="el-icon-arrow-up"></i>
            较昨日 +{{ vipUsersIncrease }}
          </div>
        </div>
      </div>
    </div>

    <!-- 图表区域 -->
    <div class="chart-container">
      <div class="chart-card">
        <div class="chart-header">
          <h3>用户增长趋势</h3>
          <el-button-group size="small">
            <el-button
              :type="chartPeriod === '7' ? 'primary' : ''"
              @click="chartPeriod = '7'"
              style="background: #ffd700; color: #000; border-color: #ffd700"
            >
              7天
            </el-button>
            <el-button
              :type="chartPeriod === '30' ? 'primary' : ''"
              @click="chartPeriod = '30'"
              style="background: #ffd700; color: #000; border-color: #ffd700"
            >
              30天
            </el-button>
            <el-button
              :type="chartPeriod === '90' ? 'primary' : ''"
              @click="chartPeriod = '90'"
              style="background: #ffd700; color: #000; border-color: #ffd700"
            >
              90天
            </el-button>
          </el-button-group>
        </div>
        <div class="chart-content">
          <div class="chart-placeholder">
            <i
              class="el-icon-data-line"
              style="font-size: 48px; color: #ffd700"
            ></i>
            <p>图表区域 - 可集成 ECharts 或其他图表库</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 快速操作区域 -->
    <div class="quick-actions">
      <div class="action-card">
        <div class="action-icon">
          <i class="el-icon-document"></i>
        </div>
        <div class="action-content">
          <div class="action-title">数据报表</div>
          <div class="action-desc">生成详细数据报告</div>
        </div>
        <el-button
          type="primary"
          size="small"
          style="background: #ffd700; color: #000; border-color: #ffd700"
        >
          生成报表
        </el-button>
      </div>

      <div class="action-card">
        <div class="action-icon">
          <i class="el-icon-refresh"></i>
        </div>
        <div class="action-content">
          <div class="action-title">数据刷新</div>
          <div class="action-desc">手动刷新最新数据</div>
        </div>
        <el-button
          type="primary"
          size="small"
          style="background: #ffd700; color: #000; border-color: #ffd700"
          @click="refreshData"
        >
          立即刷新
        </el-button>
      </div>

      <div class="action-card">
        <div class="action-icon">
          <i class="el-icon-download"></i>
        </div>
        <div class="action-content">
          <div class="action-title">数据导出</div>
          <div class="action-desc">导出Excel数据文件</div>
        </div>
        <el-button
          type="primary"
          size="small"
          style="background: #ffd700; color: #000; border-color: #ffd700"
        >
          导出数据
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainTable",
  data() {
    return {
      updateTime: "",
      chartPeriod: "7",
      totalUsers: 8456,
      totalUsersIncrease: 125,
      newUsers: 289,
      newUsersIncrease: 32,
      activeUsers: 1234,
      activeUsersIncrease: 45,
      vipUsers: 567,
      vipUsersIncrease: 8,
    };
  },
  mounted() {
    this.updateCurrentTime();
    this.loadData();
    // 每30秒更新一次时间
    setInterval(this.updateCurrentTime, 30000);
  },
  methods: {
    updateCurrentTime() {
      const now = new Date();
      this.updateTime = now.toLocaleString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },
    loadData() {
      // 这里可以调用API获取真实数据
      // 暂时使用模拟数据
      console.log("加载运营数据...");
    },
    refreshData() {
      this.$message.success("数据刷新成功！");
      this.loadData();
    },
  },
};
</script>

<style scoped>
.main-container {
  background: #faf9de;
  min-height: 100vh;
  padding: 20px;
  font-family: "fangzheng", sans-serif;
  overflow-y: auto;
}

.page-header {
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.page-header h1 {
  margin: 0;
  color: #000;
  font-size: 24px;
  font-weight: bold;
}

.update-time {
  color: #666;
  font-size: 14px;
}

.data-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.data-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 20px;
  transition: all 0.3s ease;
}

.data-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.card-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #fff;
}

.card-icon.total-users {
  background: linear-gradient(135deg, #ffd700, #ffed4a);
}

.card-icon.new-users {
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
}

.card-icon.active-users {
  background: linear-gradient(135deg, #059669, #10b981);
}

.card-icon.vip-users {
  background: linear-gradient(135deg, #dc2626, #ef4444);
}

.card-content {
  flex: 1;
}

.card-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.card-value {
  font-size: 32px;
  font-weight: bold;
  color: #000;
  margin-bottom: 8px;
}

.card-trend {
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.card-trend.positive {
  color: #059669;
}

.card-trend.negative {
  color: #dc2626;
}

.chart-container {
  margin-bottom: 24px;
}

.chart-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.chart-header h3 {
  margin: 0;
  color: #000;
  font-size: 18px;
}

.chart-content {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px dashed #ddd;
}

.chart-placeholder {
  text-align: center;
  color: #666;
}

.chart-placeholder p {
  margin: 12px 0 0 0;
  font-size: 14px;
}

.quick-actions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.action-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
}

.action-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.action-icon {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: linear-gradient(135deg, #ffd700, #ffed4a);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #000;
}

.action-content {
  flex: 1;
}

.action-title {
  font-size: 16px;
  font-weight: bold;
  color: #000;
  margin-bottom: 4px;
}

.action-desc {
  font-size: 14px;
  color: #666;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .main-container {
    padding: 16px;
  }

  .page-header {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }

  .data-cards {
    grid-template-columns: 1fr;
  }

  .chart-header {
    flex-direction: column;
    gap: 16px;
  }

  .quick-actions {
    grid-template-columns: 1fr;
  }
}
</style>
